import { store }       from 'index';
import { RESET_STATE } from 'actions';

const resetState = () => {
    store.dispatch(RESET_STATE())
}


export default resetState;
